<template>
  <div class="demo-split" id="dingwei">
    <Split v-model="split2" mode="vertical" id="dddddd">
      <div slot="top" class="demo-split-pane" style="height: 100%">
        <group-tree isMore @groups="reGroups" @group="reGroup" ref="group" :filterGroup="filterGroup"
          :noAutoLoad="true"></group-tree>
      </div>
      <div slot="bottom" class="demo-split-pane" id="bottom" style="height: 100%">
        <Input search @on-search="searchCar" v-model="keyword" placeholder="关键词搜索"></Input>
        <ul id="carmsgTab">
          <li :class="{ active: tabValue == 3 }" @click="tabs(3)">
            全部({{ allLength }})
          </li>
          <li :class="{ active: tabValue == 2 }" @click="tabs(2)">
            在线({{ onLineLength }})
          </li>
          <li :class="{ active: tabValue == 1 }" @click="tabs(1)">
            离线({{ offLineLength }})
          </li>
        </ul>
        <div class="clearfloat" v-show="carsList.length > 0" v-if="modal == 'locate'" style="margin-bottom: 10px">
          <div @click="clickCheckAll()" class="quanbu">
            {{ checkAll ? "查看全部" : "取消全部" }}
          </div>
        </div>
        <div id="carmsg" class="gundongtiao" style="min-height: 180px" v-if="modal == 'locate'">
          <li v-for="(item, index) in carsList" :key="index" @click="clickCarList(item, index)"
            :class="{ blue: item.select }" v-show="item.show">
            <div class="locateLispan">
              <img :src="axios.platConfig.fileUri + 'mapicon/' + item.icon + '/big.png'
                " class="locateIcon" />
              <span>{{ item.name }}</span>
            </div>

            <span class="locateLiright"><car-statue :realTimeStatus="item.realTimeStatus"
                :statusDuration="item.statusDuration"></car-statue></span>
          </li>
          <div v-show="tabValue == 3" class="locatenodata">
            <a v-show="noOnline.length > 0" @click="nonono = true">
              未上线设备：{{ noOnline.length }}台
            </a>
          </div>
        </div>
        <div id="carmsg" class="gundongtiao" style="min-height: 180px" v-show="carsList.length > 0"
          v-if="modal == 'video'">
          <li class="locateController" v-for="(item, index) in carsList" :key="index" :label="item.deviceId"
            @click="clickCarList(item, index)" :class="{ blue: nowSelectIndex == index }" v-show="item.show">
            <div class="locateLispan">
              <span>{{ item.name }}</span>
            </div>

            <div class="locateController">
              <car-statue :realTimeStatus="item.realTimeStatus"></car-statue>

              <!-- <Tooltip :content="item.play ? '关闭视频' : '播放视频'" placement="top" style="margin: 0 2px;"> -->
                <Button :icon="item.play ? 'md-pause' : 'md-play'" @click.prevent="playPause(item, index)"
                  size="small"></Button>
              <!-- </Tooltip> -->
              <!-- <Tooltip :content="item.IsSpeak ? '关闭对讲' : '开启对讲'" placement="top" -->
                <!-- style="display: flex;align-items: center;"> -->
                <div style="height: 22px;width: 20px;" @click.prevent="openSpeak(item, index)">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    v-if="item.IsSpeak">
                    <path fill="#1296db"
                      d="M576 701.6v-65.6c55.2-14.4 96-64 96-124s-40.8-109.6-96-124v-65.6C666.4 337.6 736 416.8 736 512s-69.6 174.4-160 189.6z m0-568v64.8c145.6 29.6 256 159.2 256 313.6 0 154.4-110.4 284-256 313.6v64.8c181.6-30.4 320-188 320-378.4S757.6 164 576 133.6zM256 384H128v256h128l256 256V128L256 384z" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 1024 1024" version="1.1" v-else>
                    <path fill="#8a8a8a"
                      d="M448 282.4v459.2L301.6 594.4 282.4 576H192V448h90.4l18.4-18.4L448 282.4M512 128L256 384H128v256h128l256 256V128z m64 5.6v64.8c145.6 29.6 256 159.2 256 313.6s-110.4 284-256 313.6v64.8c181.6-30.4 320-188 320-378.4S757.6 164 576 133.6z m0 188.8v65.6c55.2 14.4 96 64 96 124s-40.8 109.6-96 124v65.6C666.4 686.4 736 607.2 736 512s-69.6-174.4-160-189.6z" />
                  </svg>
                </div>
              <!-- </Tooltip> -->
            </div>
          </li>
        </div>
      </div>
    </Split>
    <Modal v-model="nonono" draggable title="未上线设备" footer-hide width="800">
      <Table width="100%" :height="360" :columns="columns" :data="noOnline">
      </Table>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import carStatue from "../common/carStatue.vue";
import "../common/treecss.css";
//http://www.ningbo.gov.cn//zjjcmspublic.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/jcms_files/jcms1/web2984/site/picture/0/2007161832198957535.jpg
//
var time;
var time2;
var dassdd;
let lastdeviceNo;
var myStoreData = [];
export default {
  props: ["modal", "isLive", "limit", "deviceUseType", "filterGroup"],
  data() {
    return {
      split2: 0.3,
      keyword: "",
      tabValue: 3,
      checkAll: true,
      deviceNoList: [],
      carsList: [], //获取到的车
      allLength: 0, //所有设备列表
      noOnline: [],
      onLineLength: 0,
      isFirst: true,
      offLineLength: 0,
      groupId: [], //单选模式下的指令Id数组
      groupIdList: [], //单选模式下的指令Id数组
      selectDeviceNoArr: [], //选中的车辆
      isSearch: false, //是否搜索模式
      leftLoteData: [],
      videoPlayNo: 0,
      mapRefresh: 15000,
      nonono: false,
      nowSelectIndex: -1,
      columns: [
        {
          type: "index",
          tooltip: true,
          minWidth: 70,
          maxWidth: 90,
          align: "center"
        },
        {
          title: "绑定主体",
          key: "name",
          tooltip: true
        },
        {
          title: "设备号",
          key: "deviceNo",
          tooltip: true
        },
        {
          title: "sim卡号",
          key: "simNo",
          tooltip: true
        },
        {
          title: "设备类型",
          key: "deviceModel",
          tooltip: true
        },

        {
          title: "单位名称",
          key: "groupName",
          tooltip: true
        }
      ]
    };
  },
  components: { carStatue },
  methods: {
    reGroup(y, x) {
      this.reGroups(x);
    },
    //选择用户组
    reGroups(x) {
      this.reset();

      for (const i in x) {
        this.groupIdList.push(x[i].groupId);
      }

      if (this.groupIdList.length == 0 && this.groupId.length > 0) {
        dassdd = this.groupId;
      } else {
        dassdd = this.groupIdList;
      }
      if (dassdd.length == 0) {
        return;
      }
      this.getLocateList(dassdd);
      clearInterval(time2);
      time2 = setInterval(() => {
        this.getLocateList(dassdd);
      }, this.mapRefresh);
      //this.dingshi();
    },
    //获取实时车辆列表以及位置信息

    getLocateList(groupIdList) {
      
      let d=Date.now();

      let params = {
        groupIdList: groupIdList,
        returnCoord: 2,
        keyword: this.keyword,
        deviceUseType: this.deviceUseType == undefined ? "" : this.deviceUseType
      };
      if (this.isFirst) {
        this.utils.loading(this, "加载中");
      }

      this.axios({
        method: "post",
        url: this.axios.lbs + "/locate/getLocate",
        data: params
      }).then(res => {
        this.$Spin.hide();
       console.log(params,res);
        myStoreData = [];
        this.noOnline = [];
        this.onLineLength = 0;
        this.offLineLength = 0;
        var data = res.data.data;
        if (this.modal == "video") {
          data = data.filter(function (item) {
            return item.carLabelList.includes("视频");
          });
        }
        if (this.isSearch && data.length > 0) {
          this.$refs.group.look(data[0].groupName);
        }
        this.isSearch = false;
        let length = data.length > 2000 ? 2000 : data.length;
        for (let i = 0; i < length; i++) {
          var aaa = data[i].deviceUseType;
          data[i].name =
            aaa == null
              ? data[i].deviceNo
              : aaa == 1
                ? data[i].carNo
                : data[i].personName;
          if (data[i].active) {
            data[i].select = false;
            data[i].show = true;
            data[i].play = false;

             data[i].service =
              data[i].service == null
                ? { name: "暂无", status: "未排班" }
                : JSON.parse(data[i].service);
            data[i].serviceName = data[i].service.name;
            data[i].serviceStatus = data[i].service.status;
            data[i].icon =
              aaa == null
                ? "arrow"
                : aaa == 1
                  ? data[i].carTypeIcon
                  : "person001";
            data[i].locateLng = data[i].x;
            data[i].locateLat = data[i].y;
            data[i].realTimeStatus =
              aaa == 1
                ? data[i].deviceStatus
                : data[i].deviceStatus == 1
                  ? 1
                  : 7;
            data[i].accStatus = this.$t("accStatus." + data[i].accStatus);
            data[i].flag = this.$t("flag." + data[i].flag);
            data[i].gpsTime = this.utils.time(data[i].gpsTime);
            data[i].alarmList =
              data[i].alarmList.length > 0
                ? data[i].alarmList.join(",")
                : "暂无报警";
            myStoreData.push(data[i]); 
            if (data[i].realTimeStatus == 1) {
              this.offLineLength += 1;
            } else {
              this.onLineLength += 1;
            }
          } else {
            this.noOnline.push(data[i]);
          }
        }

        if (this.isFirst) {
          this.carsList = myStoreData;
          this.allLength = data.length;
        }
        this.isFirst = false;
        //this.tabs(this.tabValue);
      });
    },
    //选项卡
    tabs(x) {
      if (!this.checkAll) {
        //切换的时候，如果有车辆在选中，先全部取消选中
        this.clickCheckAll();
      }
      this.tabValue = x;
      for (const i in this.carsList) {
        this.carsList[i].show = true;
        if (x == 1 && this.carsList[i].realTimeStatus != 1) {
          this.carsList[i].show = false; //离线,把不是离线的隐藏
        } else if (x == 2 && this.carsList[i].realTimeStatus == 1) {
          this.carsList[i].show = false; //在线，把离线的隐藏
        }
      }
    },
    //点击选择全部，取消全部
    clickCheckAll() {
      if (this.carsList.length > 800 && this.checkAll) {
        this.$Message.error("超过800台，该功能禁止");
        return;
      }
      this.selectDeviceNoArr = [];
      for (const i in this.carsList) {
        if (this.carsList[i].show) {
          this.carsList[i].select = this.checkAll;
          if (this.carsList[i].select) {
            this.selectDeviceNoArr.push(this.carsList[i].deviceNo);
          }
        }
      }
      this.isToCenter = true;
      this.dingshi();
    },
    //点击单台车辆false
    clickCarList(row, index) {
      if (this.modal == "locate") {
        this.carsList[index].select = !this.carsList[index].select;
        lastdeviceNo = row.deviceNo;
        //首先删除已经选过的车
        for (let k = 0; k < this.selectDeviceNoArr.length; k++) {
          if (row.deviceNo == this.selectDeviceNoArr[k]) {
            //arr.splice(index,n,m) index-位置，n个数，m-替换的数据
            this.selectDeviceNoArr.splice(k, 1);
          }
        }
        //然后判断，如果该条目为选中，则把条目设备ID添加进来
        if (this.carsList[index].select) {
          this.selectDeviceNoArr.push(row.deviceNo);
        }
        this.isToCenter = true;
        this.dingshi();
      } else {
        this.nowSelectIndex = index;
        this.$emit("car", row);
      }
    },
    //搜索车辆
    searchCar() {
      this.reset();
      this.isSearch = true;
      this.getLocateList([]);
      time2 = setInterval(() => {
        this.getLocateList([]);
      }, this.mapRefresh);
    },
    clearSearch() {
      if (this.isSearch) {
        this.$refs.group.look("");
      }
      this.isSearch = false;
    },
    //取出车来给你渲染到地图并更新左侧列表
    takeOutCarToMap(v) {
      var goleData = [];

      for (let i = 0; i < myStoreData.length; i++) {
        //更新列表车辆状态和时长
        this.carsList[i].realTimeStatus = myStoreData[i].realTimeStatus;

        this.carsList[i].statusDuration = myStoreData[i].statusDuration;
        //更新地图数据
        if (v.includes(myStoreData[i].deviceNo)) {
          if (myStoreData[i].deviceNo == lastdeviceNo) {
            goleData.push(myStoreData[i]);
          } else {
            goleData.unshift(myStoreData[i]);
          }
        }
      }
      return goleData;
    },
    dingshi() {
      clearInterval(time);
      var x = this.takeOutCarToMap(this.selectDeviceNoArr);
      this.$emit("selectCarList", x, this.isToCenter);
      this.isToCenter = false;
      if (this.selectDeviceNoArr.length == 0) {
        return;
      }
      time = setInterval(() => {
        var x = this.takeOutCarToMap(this.selectDeviceNoArr);
        this.$emit("selectCarList", x, this.isToCenter);
      }, this.mapRefresh + 100);
    },
    //离开页面后要暂停定时器
    pause() {
      clearInterval(time);
      clearInterval(time2);
    },
    //长时间离开页面回来后，重新开始
    reStart() {
      time2 = setInterval(() => {
        this.getLocateList(dassdd);
      }, this.mapRefresh);
      this.dingshi();
    },
    playPause(row, index) {
      if (row.play) {
        //如果播放
        this.carsList[index].play = false;
        this.videoPlayNo -= 1;
        this.$emit("videoCmd", row);
      } else {
        this.carsList[index].play = true;
        this.videoPlayNo += 1;
        this.$emit("videoCmd", row);
      }
    },
    openSpeak(row, index) {
      // 是否正在对讲
      // console.log("this.carsList[index].IsSpeak", this.carsList[index].IsSpeak);

      /* if (row.IsSpeak) {
        this.carsList[index].IsSpeak = false;
        this.$emit("closeSpeak", row);
      } else {
        this.carsList[index].IsSpeak = true;


      } */
      this.$emit("openSpeak", row);
    },

    reset() {
      clearInterval(time);
      clearInterval(time2);
      this.carsList = [];
      this.selectDeviceNoArr = [];
      myStoreData = [];
      this.groupIdList = [];
      this.noOnline = [];
      this.tabValue = 3;
      this.deviceNoList = [];
      this.allLength = 0;
      this.onLineLength = 0;
      this.offLineLength = 0;
      this.isFirst = true;
      this.isToCenter = false;
      this.$emit("selectCarList", [], this.isToCenter);
    },
    weishangxianFun(v) {
      this.noOnline = v;
      for (let i = 0; i < v.length; i++) { }
    }
  },
  watch: {
    selectDeviceNoArr(v) {
      if (v.length > 0) {
        this.checkAll = false;
      } else {
        this.checkAll = true;
      }
    }
  },
  beforeDestroy() {
    // this.$emit("closeSpeak", {});
  },
  destroyed() {
    this.reset();

    // console.log('销毁了定位页面')
  },
  deactivated() {
    // console.log("我现在离开");
    this.pause();
  },
  activated() {
    console.log("我已经回来");
    if (this.groupIdList.length>0) {
      this.reStart();
    }

  },
  mounted() {

  }
};
</script>

<style scoped>
.DropdownList {
  padding: 0 2px;
  color: #fff;
  background-color: #4499f3;
  font-size: 12px;
  border-radius: 4px;
  height: 18px;
  line-height: 18px;
  margin-top: 4px;
  margin-left: 1px;
}

.ivu-dropdown-menu {
  min-width: 30px !important;
}

.locateLispan {
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 隐藏溢出的文本 */
  text-overflow: ellipsis;
  /* 显示省略符号来代表被修剪的文本 */
}

.locateController {
  display: flex;
  align-items: center;
}

.locateController .ivu-tooltip-rel {
  display: flex !important;
}
</style>



// WEBPACK FOOTER //
// src/components/locate/locateToolCarPerson.vue